import { Button } from '@/components/ui/button'
import { formatFileSize, validateAttachmentFiles } from '@/lib/attachments'
import { Trash2 } from 'lucide-react'
import { toast } from 'sonner'
import { SkillAttachmentRow, SkillAttachmentsLayout } from './SkillAttachmentsLayout'

interface PendingSkillAttachmentsPanelProps {
  files: File[]
  onFilesChange: (files: File[]) => void
  isLocked: boolean
}

export function PendingSkillAttachmentsPanel({ files, onFilesChange, isLocked }: PendingSkillAttachmentsPanelProps) {
  const onFilesSelected = (selected: File[]) => {
    const { valid, errors } = validateAttachmentFiles(selected, files.length, files.reduce((sum, file) => sum + file.size, 0))
    errors.forEach(message => toast.error(message))
    if (valid.length > 0) onFilesChange([...files, ...valid])
  }

  return (
    <SkillAttachmentsLayout
      canEdit
      isEmpty={files.length === 0}
      isUploading={isLocked}
      note="Uploaded when you save the skill."
      onFilesSelected={onFilesSelected}
    >
      {files.map((file, index) => (
        <SkillAttachmentRow key={`${file.name}-${index}`} fileName={file.name} details={`${formatFileSize(file.size)} · Not uploaded yet`}>
          <Button
            variant="ghost"
            size="sm"
            className="text-destructive"
            onClick={() => onFilesChange(files.filter((_, i) => i !== index))}
            disabled={isLocked}
            aria-label={`Remove ${file.name}`}
          >
            <Trash2 className="h-4 w-4" />
            Remove
          </Button>
        </SkillAttachmentRow>
      ))}
    </SkillAttachmentsLayout>
  )
}
